import { useState } from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const EmotionalLevelLineChart = (props) => {
  const { config, min, max } = props;

  const COLORS = ["#8884d8", "#82ca9d", "#FF8042"];
  const renderXAxis = () => <XAxis dataKey={config.datakeys[0]} />;

  const renderYAxis = () => {
    return <YAxis />;
  };

  const renderLegend = () => {
    return <Legend verticalAlign="bottom" align="left" height={36} />;
  };

  const renderChartData = () => {
    if (config.datakeys && config.datakeys.length) {
      return config.datakeys.map((item, index) => {
        const backgroundColor = config.backgroundColor ? config.backgroundColor : COLORS[index];
        return (
          <Line
            key={index}
            type="basis"
            dataKey={item}
            stroke={backgroundColor}
            dot={false}
          />
        );
      });
    }
  };

  const render = () => {
    if (config && config.data && config.data.length)
      return (

        <ResponsiveContainer width="100%" height={'100%'}>
          <LineChart
            width={500}
            height={300}
            data={config.data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            {renderXAxis()}
            {renderYAxis()}
            {config.tooltip ? (
              <Tooltip content={config.tooltip} />
            ) : (
              <Tooltip />
            )}
            {renderLegend()}
            {renderChartData()}
          </LineChart>
        </ResponsiveContainer>

      );
    return <p className="d-flex align-items-center justify-content-center">Loading...</p>;
  };
  return render();
};

export default EmotionalLevelLineChart;
